export const QUANTITY_LIMIT = 14999;
export const DEFAULT_QUANTITY = 20;
export const CNC_FILE_SIZE_LIMIT = 3 * 1024 * 1024; // 3MB
